import { push as routerPush } from 'redux-first-history';
import sysend from 'sysend';

import { fetchConfig } from 'common/actions/config';
import { LOGIN_PATH } from 'common/selectors/sidebar/common';
import { USER_SESSION_EXPIRED, USER_IS_BLOCKED } from 'users/actions/auth';
import {
  loginSuccessAction,
  logoutSuccessAction,
  resetUserAuthAction,
} from 'users/reducers/auth';
import { resetStoresAction } from 'common/actions/common';

/**
 * Auth middleware function
 */
const middleware = (store) => (next) => (action) => {
  const { dispatch } = store;

  const result = next(action);

  const checkUserId = () => {
    const { user } = store.getState().config;

    sysend.broadcast('userIdCheck', { id: user ? user.id : undefined });
  };

  switch (action.type) {
    case resetUserAuthAction.type: {
      checkUserId();
      dispatch(logoutSuccessAction());
      dispatch(resetStoresAction());
      break;
    }
    case USER_IS_BLOCKED: {
      dispatch(routerPush(LOGIN_PATH));
      dispatch(fetchConfig());
      break;
    }

    case USER_SESSION_EXPIRED: {
      dispatch(routerPush(LOGIN_PATH));
      dispatch(fetchConfig());
      break;
    }

    case loginSuccessAction.type: {
      checkUserId();
      break;
    }

    default:
      break;
  }

  return result;
};

export default middleware;
